import React, { useState } from 'react';
import styled from 'styled-components';
import { FiMail, FiSend, FiCheck } from 'react-icons/fi';
import { theme } from '../theme';
import { subscribeNewsletter } from '../services/api';
import { t, locale } from '../config/i18n';

const Wrap = styled.div`max-width: 420px;`;
const Title = styled.h4`
  display: flex; align-items: center; gap: 0.45rem;
  font-family: ${theme.fonts.heading}; font-size: 0.95rem; font-weight: 700;
  color: ${theme.colors.textPrimary}; margin-bottom: 0.4rem;
  svg { color: ${theme.colors.secondary}; }
`;
const Sub = styled.p`color: ${theme.colors.textMuted}; font-size: 0.82rem; margin-bottom: 0.8rem; line-height: 1.5;`;
const Form = styled.form`display: flex; gap: 0.5rem; flex-wrap: wrap;`;
const Input = styled.input`
  flex: 1; min-width: 180px;
  background: ${theme.colors.bgPrimary}; color: ${theme.colors.textPrimary};
  border: 1px solid ${theme.colors.border}; border-radius: ${theme.radii.full};
  padding: 0.6rem 1rem; font-size: 0.88rem;
  &:focus { outline: none; border-color: ${theme.colors.borderHover}; }
`;
const Btn = styled.button`
  display: inline-flex; align-items: center; gap: 0.4rem;
  padding: 0.6rem 1.2rem; border: none; cursor: pointer;
  background: ${theme.colors.gradient}; border-radius: ${theme.radii.full};
  color: #fff; font-size: 0.85rem; font-weight: 600; transition: ${theme.transitions.default};
  &:hover:not(:disabled) { filter: brightness(1.1); transform: translateY(-1px); }
  &:disabled { opacity: 0.6; cursor: default; }
`;
const Msg = styled.p`
  margin-top: 0.6rem; font-size: 0.8rem;
  color: ${({ $ok }) => ($ok ? theme.colors.success : theme.colors.accent)};
`;

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | loading | ok | err
  const [msg, setMsg] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setState('err'); setMsg(t('nl.invalid')); return; }
    setState('loading');
    const r = await subscribeNewsletter(email, locale);
    if (r && r.ok) { setState('ok'); setMsg(t('nl.ok')); setEmail(''); }
    else { setState('err'); setMsg(r && r.error === 'invalid' ? t('nl.invalid') : t('nl.err')); }
  };

  return (
    <Wrap>
      <Title><FiMail /> {t('nl.title')}</Title>
      <Sub>{t('nl.sub')}</Sub>
      {state === 'ok' ? (
        <Msg $ok><FiCheck style={{ verticalAlign: 'middle' }} /> {msg}</Msg>
      ) : (
        <>
          <Form onSubmit={onSubmit}>
            <Input
              type="email" value={email} placeholder={t('nl.placeholder')}
              onChange={(e) => setEmail(e.target.value)} aria-label="email"
            />
            <Btn type="submit" disabled={state === 'loading'}>
              <FiSend /> {t('nl.button')}
            </Btn>
          </Form>
          {state === 'err' && <Msg>{msg}</Msg>}
        </>
      )}
    </Wrap>
  );
}
